import React from "react"
import {
  TextFields,
  InsertPhoto,
  InfoOutlined,
  Warning,
  Error,
  AttachFile,
  PlayCircleFilledOutlined,
} from "@material-ui/icons"
import { KNOWLEDGE_CONTENT_TYPE } from "../../data"

const KnowledgeContentTypeIcon = ({ type, ...rest }) => {
  switch (type) {
    case KNOWLEDGE_CONTENT_TYPE.TEXT:
      return <TextFields {...rest} />
    case KNOWLEDGE_CONTENT_TYPE.IMAGE:
      return <InsertPhoto {...rest} />
    case KNOWLEDGE_CONTENT_TYPE.NOTE:
      return <InfoOutlined {...rest} />
    case KNOWLEDGE_CONTENT_TYPE.NOTE_IMPORTANT:
      return <Warning {...rest} />
    case KNOWLEDGE_CONTENT_TYPE.NOTE_DANGER:
      return <Error {...rest} />
    case KNOWLEDGE_CONTENT_TYPE.FILES:
      return <AttachFile {...rest} />
    case KNOWLEDGE_CONTENT_TYPE.VIDEO:
      return <PlayCircleFilledOutlined {...rest} />
    default:
      return null
  }
}

export { KnowledgeContentTypeIcon }
